
const countries = require('./countries.json');

export function getCountryName(code) {
  const res = countries.find(_ => _.code === code);
  return res ? res.name : undefined;
}